export const networkManagementEndPoints = {
    affordabilitySummary: 'affordability/summary',
    affordabilityQuickFilters: 'affordability/top-filter',
    affordabilityImpactByTaxID: 'affordability/impact-by-taxid',
    affordablityHRLDetailsPage: 'affordability/hospital-reference-lab-details',
    affordabilitySOSDetailsPage: 'affordability/site-of-service-details',
    affordabilitySummaryExport: 'affordability/export-details',
    affordabilityRadCardDetails: 'affordability/radio-cardio-pa-details',
    affordabilityMedSourceMpinTable: 'affordability/medication-sourcing-mpin-details',
    affordabilityProgramDetails: 'affordability/program-details',
    affordabilityDDPMPINTable: 'affordability/ddp-mpin-details',
    vbtDetails: 'value-based-trade/details',
    affordabilityMPINTable: 'affordability/mpin-details',
    aprnExclusion: 'aprn-exclusion',
    aprnExclusionHome: 'download-file/APRN',
    claimsPaidActive: 'poca/activated-tins-claims',
    APRNDateFilter: 'date-filter-source/APRN',
    SOSMarketShareCurrentDateFilter: 'date-filter-source/SOSMarketShareCurrentTimePeriod',
    SOSMarketSharePriorDateFilter: 'date-filter-source/SOSMarketSharePriorTimePeriod',
    DigitalSolutionDateFilter: 'date-filter-source/DigitalSolutions'
  };


  